// extracted by mini-css-extract-plugin
export var avatarContainer = "_3x-1";
export var largeAvatarContainer = "_3x-2";
export var smallAvatarContainer = "_3x-0";